export const VALIDATION_ERRORS = {
  MANDATORY: 'mandatory',
};
